module.exports = __webpack_public_path__ + "static/media/adpathy.d8c8687c.png";